<template>
    <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :close-on-backdrop="false" :centered="false" :title="title" :size="'lg'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
        <div class="px-3 row d-flex">
            <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12">
                <label for="birthday" class="mb-1">N° de Documento</label>
                <div class="d-flex align-items-center">
                    <div class="input-group me-1">
                        <span class="input-group-text">
                            <i class="fa fa-id-card"></i>
                        </span>
                        <input 
                            type="text" 
                            class="form-control" 
                            id="num_document" 
                            placeholder="N° de Documento" 
                            maxlength="8" 
                            v-model="data_detail.document_remission"
                            @keypress="isNumber($event)" 
                        />
                    </div>
                    <button class="btn bg-main text-white" type="button" @click="mtdSearchDocument()">
                        <i class="fa fa-search"></i>
                    </button>
                </div>
            </div>

            <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-xs-12">
                <label for="birthday" class="mb-1">Nombres</label>
                <div class="input-group">
                    <span class="input-group-text">
                        <i class="fa fa-user"></i>
                    </span>
                    <input type="text" class="form-control" id="name" placeholder="Nombre"  v-model="data_detail.name_remission"  disabled/>
                </div>
            </div>
        </div>

        <div class="px-3 row d-flex mt-2">
            <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-xs-12">
                <label for="birthday" class="mb-1">N° de Guia</label>
                <div class="input-group">
                    <span class="input-group-text">
                        <i class="fas fa-receipt"></i>
                    </span>
                    <input type="text" class="form-control" v-model="data_detail.guide_remission" placeholder="N° de Guia"/>
                </div>
            </div>
            <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-xs-12">
                <label for="birthday" class="mb-1">Firma</label>
                <div class="input-group">
                    <span class="input-group-text">
                        <i class="fas fa-solid fa-signature"></i>
                    </span>
                    <input type="file" class="form-control" lang="es" name="file" ref="fileInputSigna" @change="getFileSigna" />
                </div>
            </div>
        </div>

        <div class="px-3 row d-flex mt-3">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                <label for="birthday" class="mb-1">Archivo</label>
                <div class="input-group">
                    <span class="input-group-text">
                        <i class="fas fa-folder-open"></i>
                    </span>
                    <input type="file" class="form-control" lang="es" name="file" ref="fileInput" @change="getFile"/>
                </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 text-end">
                <button class="btn bg-main text-white" type="button" @click="checkFields()" :disabled="cpButton">
                    <i class="fas fa-save"> Guardar</i>
                </button>
            </div>
        </div>
        <p v-if="lastClicked" class="mt-2 text-center mt-1">
            Última hora de Guardado: <span>{{ lastClicked }}</span>
        </p>
        <SweetAlert :swal="swal" ref="SweetAlert" />
    </CModal>
</template>

<script>
import moment from "moment";
import CModal from "@/components/shared/modals/CModal.vue";
import SweetAlert from '@/components/shared/SweetAlert/SweetAlert.vue';
import {
    mapActions
} from "vuex";

export default {
    name: "c-maintenance-modal-guideRemi",
    components: {
        CModal,
        SweetAlert
    },
    data() {
        return {
            swal: null,
            data_detail: {
                document_remission: '',
                name_remission: '',
                signature_remission: '',
                guide_remission: '',
                file: ''
            },
            lastClicked: null,
        };
    },
    watch: {
        payload: {
            handler(newVal) {
            },
            immediate: true,
        },
    },
    props: {
        title: String,
        boo_modal: Boolean,
    },
    computed: {
        cpButton() {
            return (
                // !this.data_detail.document_remission.trim() ||
                // !this.data_detail.name_remission.trim() ||
                !this.data_detail.guide_remission.trim()
            );
        }
    },
    methods: {
        ...mapActions(["get", "post"]),
        
        mtdClose() {
            this.$emit("closeModal");
        },

        isNumber(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        
        mtdSearchDocument: function () {
            if (this.data_detail.document_remission.length == 8) {
                this.get({
                    url: this.$store.getters.get__url + "/reniec/" + this.data_detail.document_remission,
                    token: this.$store.getters.get__token,
                })
                    .then((response) => {

                        if (response.data.boo == 3) {
                            this.$refs.SweetAlert.showWarning("DNI no encontrado");
                            this.data_detail.document_remission = '',
                            this.data_detail.name_remission = ''
                        } else {
                            this.data_detail.name_remission = response.data.name + " " + response.data.last_name;
                        }
                    })
                    .catch((errors) => {
                        this.$refs.SweetAlert.showError(errors);
                    });
            } else {
                this.data_detail.document_remission = '',
                this.data_detail.name_remission = ''
            }
        },

        getFile(e) {
            let fileInput = this.$refs.fileInput;
            let file = e.target.files[0];
            if (!/\.(pdf)$/i.test(file.name) && !/\.(png)$/i.test(file.name) && !/\.(jpg)$/i.test(file.name) && !/\.(jpeg)$/i.test(file.name)) {
                this.$refs.SweetAlert.showInfo("Seleccione un archivo formato PDF, PNG O JPG");
                fileInput.value = '';
                this.data_detail.file = '';
            } else {
                this.data_detail.file = file;
            }
        },

        getFileSigna(e) {
            let fileInputSigna = this.$refs.fileInputSigna;
            let file = e.target.files[0];
            if (!/\.(png)$/i.test(file.name) && !/\.(jpg)$/i.test(file.name) && !/\.(jpeg)$/i.test(file.name)) {
                this.$refs.SweetAlert.showInfo("Seleccione un archivo formato PNG O JPG");
                fileInputSigna.value = '';
            } else {
                this.data_detail.signature_remission = file;
            }
        },

        clear(){
            let fileInput = this.$refs.fileInput;
            fileInput.value = '';
            this.lastClicked = null;
            this.data_detail = {
                document_remission: '',
                name_remission: '',
                signature_remission: '',
                guide_remission: '',
                file: ''
            }
        },

        checkFields() {
            let result;
            if (
                !this.data_detail.document_remission.trim() ||
                !this.data_detail.name_remission.trim() ||
                !this.data_detail.guide_remission.trim()
            ) {
                result = 1;
            } else {
                result = 0;
            }
            this.lastClicked = moment().format('HH:mm:ss');
            this.$emit('check_fields_result', result, this.data_detail);
            this.$refs.SweetAlert.showSuccess("Datos Guardados");
            this.$emit("closeModal");
        },

    },
    

};
</script>
<style scoped>
.italic {
  font-style: italic;
}
</style>